var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network"},[_c('h3',[_vm._v(" Oops! There seems to be an issue with your network connection. Please go back and try again or go to the "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("homepage")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }